class scrollAnimation {
    constructor(options) {
        this.targetY = options.targetY ?? 0;
        this.duration = options.duration || 600;
        this.start = 0;
        this.startY = window.pageYOffset;
    }

    scroll() {
        const diff = this.targetY - this.startY;

        const step = (timestamp) => {
            if (!this.start) {
                this.start = timestamp;
            }

            const time = timestamp - this.start;
            const percent = Math.min(time / this.duration, 1);

            window.scrollTo(0, this.startY + (diff * percent));

            if (time < this.duration) {
                this.animationName = window.requestAnimationFrame(step.bind(this));
            }
        };

        this.animationName = window.requestAnimationFrame(step.bind(this));
    }
}

export default scrollAnimation;
